/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserReportStatus } from './UserReportStatus';
import {
    UserReportStatusFromJSON,
    UserReportStatusFromJSONTyped,
    UserReportStatusToJSON,
    UserReportStatusToJSONTyped,
} from './UserReportStatus';
import type { UserReportSource } from './UserReportSource';
import {
    UserReportSourceFromJSON,
    UserReportSourceFromJSONTyped,
    UserReportSourceToJSON,
    UserReportSourceToJSONTyped,
} from './UserReportSource';
import type { UserReportCategory } from './UserReportCategory';
import {
    UserReportCategoryFromJSON,
    UserReportCategoryFromJSONTyped,
    UserReportCategoryToJSON,
    UserReportCategoryToJSONTyped,
} from './UserReportCategory';

/**
 * Schema for reading a report, with reporter and handler names for the triage table.
 * @export
 * @interface UserReportRead
 */
export interface UserReportRead {
    /**
     * 
     * @type {UserReportCategory}
     * @memberof UserReportRead
     */
    category: UserReportCategory;
    /**
     * 
     * @type {string}
     * @memberof UserReportRead
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UserReportRead
     */
    description: string;
    /**
     * 
     * @type {UserReportSource}
     * @memberof UserReportRead
     */
    source: UserReportSource;
    /**
     * 
     * @type {string}
     * @memberof UserReportRead
     */
    page_url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserReportRead
     */
    user_agent?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserReportRead
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserReportRead
     */
    user_id: string;
    /**
     * 
     * @type {UserReportStatus}
     * @memberof UserReportRead
     */
    status: UserReportStatus;
    /**
     * 
     * @type {string}
     * @memberof UserReportRead
     */
    admin_note?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserReportRead
     */
    handled_by?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UserReportRead
     */
    handled_at?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof UserReportRead
     */
    created_at: Date;
    /**
     * 
     * @type {string}
     * @memberof UserReportRead
     */
    reporter_username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserReportRead
     */
    reporter_email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserReportRead
     */
    handled_by_username?: string | null;
}



/**
 * Check if a given object implements the UserReportRead interface.
 */
export function instanceOfUserReportRead(value: object): value is UserReportRead {
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}

export function UserReportReadFromJSON(json: any): UserReportRead {
    return UserReportReadFromJSONTyped(json, false);
}

export function UserReportReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserReportRead {
    if (json == null) {
        return json;
    }
    return {
        
        'category': UserReportCategoryFromJSON(json['category']),
        'title': json['title'],
        'description': json['description'],
        'source': UserReportSourceFromJSON(json['source']),
        'page_url': json['page_url'] == null ? undefined : json['page_url'],
        'user_agent': json['user_agent'] == null ? undefined : json['user_agent'],
        'id': json['id'],
        'user_id': json['user_id'],
        'status': UserReportStatusFromJSON(json['status']),
        'admin_note': json['admin_note'] == null ? undefined : json['admin_note'],
        'handled_by': json['handled_by'] == null ? undefined : json['handled_by'],
        'handled_at': json['handled_at'] == null ? undefined : (new Date(json['handled_at'])),
        'created_at': (new Date(json['created_at'])),
        'reporter_username': json['reporter_username'] == null ? undefined : json['reporter_username'],
        'reporter_email': json['reporter_email'] == null ? undefined : json['reporter_email'],
        'handled_by_username': json['handled_by_username'] == null ? undefined : json['handled_by_username'],
    };
}

export function UserReportReadToJSON(json: any): UserReportRead {
    return UserReportReadToJSONTyped(json, false);
}

export function UserReportReadToJSONTyped(value?: UserReportRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': UserReportCategoryToJSON(value['category']),
        'title': value['title'],
        'description': value['description'],
        'source': UserReportSourceToJSON(value['source']),
        'page_url': value['page_url'],
        'user_agent': value['user_agent'],
        'id': value['id'],
        'user_id': value['user_id'],
        'status': UserReportStatusToJSON(value['status']),
        'admin_note': value['admin_note'],
        'handled_by': value['handled_by'],
        'handled_at': value['handled_at'] == null ? undefined : ((value['handled_at'] as any).toISOString()),
        'created_at': ((value['created_at']).toISOString()),
        'reporter_username': value['reporter_username'],
        'reporter_email': value['reporter_email'],
        'handled_by_username': value['handled_by_username'],
    };
}

